import { useQuery } from "@tanstack/react-query";
import { client } from "@/lib/hono";
import { InferResponseType } from "hono";

export type GetStoragePresetsResponseType = InferResponseType<
    typeof client.api.storage.preset.$get,
    200
>;
export type StoragePreset = GetStoragePresetsResponseType["data"][0];

export const useGetStoragePresets = (options?: { enabled?: boolean }) => {
    return useQuery({
        enabled: options?.enabled,
        queryKey: ["storage-presets"],
        queryFn: async () => {
            const response = await client.api.storage.preset.$get();

            if (!response.ok) {
                throw new Error("Failed to fetch storage presets");
            }

            const { data } = await response.json();
            return data;
        },
    });
};
